<template>
  <div
    class="form-group"
    @dblclick="dblclk"
  >
    <label v-if="label">
      {{ label }}<slot />
    </label>

    <date-picker v-if="type=='datetimepicker' || type=='datepicker' || type=='time'"
        class="form-control border-input error"
        v-bind="$props"
        :confirm="true"
        @confirm="$emit('confirm',$event)"
        :confirmText="translate('config.apply')"
        v-model="datepicker_data"
        :format = format
        :type="(type=='datetimepicker') ? 'datetime' : (type=='datepicker') ? 'date' : 'time'"
        :range = range
        valueType="X"
        @input="$emit('input',$event)"
        @clear="$emit('clear',$event)"
        @close="$emit('close',$event)"
        @keydown="$emit('keydown',$event)"
    />

    <input v-else
      :id="id"
      :name="name"
      class="form-control border-input error"
      v-bind="$props"
      :value="value"
      :autocomplete="autocomplete"
      :class="{error:error}"
      :min="min"
      :max="max"
      @input="$emit('input',$event.target.value)"
      @keydown="$emit('keydown',$event)"
      @keyup="$emit('keyup',$event)"
      @focusout="$emit('focusout',$event)"
    >
  </div>
</template>
<script>

import DatePicker from 'components/UIComponents/Datepicker2/index.js';
//import DatePick from 'components/UIComponents/Datepicker2/datepicker.vue';

/* import 'vue2-datepicker/index.css'; */

export default {
  components: {
    //DatePick
   DatePicker
  },
  data () {
    return {
      /* start_date: new Date(2021, 2, 1), */
      datepicker_data: new Date(),
    }
  },
  mounted () {

    this.datepicker_data = this.value

  },

  watch : {
    datepicker_data() {

    }
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    disabledDate:Function,
    formatter: Object,
    format: String,
    range: Boolean,
    label: String,
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    placeholder: String,
    value: [String, Number, Array],
    error: {
      type: Boolean,
      default: false
    },
    id: String,
    min: Number,
    max: Number,
    autocomplete: {
      type: String,
      default: 'off'
    },
  },
  methods: {

    /* disabledTwoMonth(date) {
        const today = new Date();
        return date > new Date(today.getTime()) || date < new Date(today.getTime() - 60 * 24 * 3600 * 1000);
    },
 */
    dblclk () {
      if (this.type === 'text' && this.readonly) {
        if (navigator.clipboard !== undefined) {
          this.$clipboard.copy(this.value)
        } else {
          let range = document.createRange()
          window.getSelection().addRange(range)
          try {
            document.execCommand('copy')
            this.global_notify('info', this.translate('clipboard.value_save_buffer'))
          } catch (err) {
            console.log('Can`t copy')
          }
        }
      }
    }
  }
}

</script>
<style lang="scss" scoped>

  .error {
    border-color: red;
  }

  // .form-group label{
  //   font-size: 13px;
  //   margin-bottom: 0;
  // }



</style>
